import { render, staticRenderFns } from "./TaxExemptFormList.vue?vue&type=template&id=5ece7dfe&web=true&"
import script from "./TaxExemptFormList.vue?vue&type=script&lang=ts&"
export * from "./TaxExemptFormList.vue?vue&type=script&lang=ts&"
import style0 from "./TaxExemptFormList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VChipGroup,VDataTable})
